import { arrayToObject } from "./arrayToObject.mjs";
export function indexBy(arr, keyFn) {
    if (typeof keyFn !== 'function') {
        var key_1 = keyFn;
        // eslint-disable-next-line @typescript-eslint/ban-types,@typescript-eslint/no-base-to-string
        keyFn = (function (value) { return value[key_1].toString(); });
    }
    return arrayToObject(arr, function (val) {
        var _a;
        return (_a = {}, _a[keyFn(val)] = val, _a);
    });
}
